import "core-js/modules/es.object.assign.js";
import "core-js/modules/es.function.bind.js";
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React, { useMemo } from 'react';
import moment from 'moment';
import CalendarInputCore from "../../../../components/core/input/CalendarInput";
var CalendarInputWrapper = function CalendarInputWrapper(props) {
  var maxDate = useMemo(function () {
    var currentYear = moment().year();
    return moment().year(currentYear + 20);
  }, []);
  return /*#__PURE__*/React.createElement(CalendarInputCore, _extends({
    maxDate: maxDate
  }, props));
};
export default CalendarInputWrapper;